import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { Row, Col, Label, Input, Form, FormGroup, Button, Card } from "reactstrap";
import { useForm } from "react-hook-form";
import Dropzone from 'react-dropzone-uploader';
import axios from 'axios';
import { toast } from "react-toastify";
import Swal from 'sweetalert2';

import RequiredIndicator from '../../../../partial/RequiredIndicator';
import { useDispatch, useSelector } from "react-redux";
import { mykyc } from '../../../../../redux/kyc/action';
import handleupload from '../../../../../utilities/handleUpload';
import validateFile from '../../../../../utilities/validateFile';
import PDFViewer from '../../../../../utilities/PDFViewer';
import { Edit, InfoOutlined } from '@mui/icons-material';
import FileUploadComponent from '../../../../common/FileUpload';
import KycEditNote from '../../kyc_note/KycEditNote';
import KycViewNote from '../../kyc_note/KycViewNote';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import specialCharacterConstrains from '../../../../../utilities/specialCharacterConstrains';
import { updateDealerDetails } from '../../../../../api';

const BankDetails = (props) => {
  const { activeStep, setActiveStep, setStep4Valid, dealerKycData, is_kyc_submitted, is_kyc_active, setIsUpdated } = props;

  const { register, getValues, setValue, handleSubmit, errors, setError, trigger } = useForm();
  const [loading, setLoading] = useState(false);
  const [cancelChequeUrl, setCancelChequeUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const kycData = useSelector((content) => content.Kyc);
  const dispatch = useDispatch();
  const [fileUploadFlag, setFileUploadFlag] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [originalValues, setOriginalValues] = useState({});

  const submitForm = async (data) => {
    setLoading(true);
    data.cancelled_cheque_number = 'NA';
    dispatch(mykyc({ ...kycData, bankDetails: { ...kycData.bankDetails, ...data }, txnid: Date.now() }));
    setIsUpdated(true)
    setTimeout(() => {
      setIsUpdated(false)
    }, 2000);
    if (activeStep === 3) {
      setStep4Valid(true);
      setLoading(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

  };
  // called every time a file's `status` change

  useEffect(() => {

    async function checkDetails() {
      const storedData = kycData.bankDetails;
      Object.keys(storedData).forEach(async (fieldName) => {
        await setValue(fieldName, storedData[fieldName]);
      });
      setCancelChequeUrl(getValues()["cancelled_cheque_image"])
    }

    checkDetails()

  }, []);

  const handleBack = () => {
    if (is_kyc_submitted) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      const rhfdata = getValues()
      dispatch(mykyc({ ...kycData, bankDetails: { ...kycData.bankDetails, ...rhfdata }, txnid: Date.now() }));
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const onSubmitForKycSubmitComplete = () => {
    if (activeStep === 3) {
      setStep4Valid(true);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  }

  const updateBankDetails = async (data) => {
    setLoading(true); // start loader
    try {
      const dealership_id = getFromLocalStorage("user")?.dealerInfo?.dealership_id;
      const kycId = getFromLocalStorage("user")?.dealerInfo?.dealership_kyc_detail.kyc_id;
      const dealerMail = getFromLocalStorage("user")?.dealerInfo?.email;
      const userMail = getFromLocalStorage("user")?.email;
      const userName = getFromLocalStorage("user")?.name;
      const isBankDetailsUpdate = true;
      // const isAuthSignatoryUpdate = false;

      const commonData = { dealership_id, kycId, dealerMail, userMail, userName, isBankDetailsUpdate};
      const updateField = data;
      const payload = { updateField, commonData };
      const updateDetails = await updateDealerDetails(payload);

      setLoading(false);
      if (updateDetails.status === 200) {
        await Swal.fire({
          icon: 'success',
          title: 'Updated Successfully',
          text: updateDetails.data.result.message,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const handleEditSave = async (data) => {
    const changedFields = Object.keys(data).reduce((acc, key) => {
      if (data[key] === undefined) return acc;
      if (String(data[key] ?? '') !== String(originalValues[key] ?? '')) {
        acc[key] = data[key];
      }
      return acc;
    }, {});

    if (Object.keys(changedFields).length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Changes',
        text: 'You have not made any changes.',
      });
      return;
    }

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to update the bank details?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      // console.log('Updated Bank Details (changed fields only):', changedFields);
      await updateBankDetails(changedFields);
      setIsEditing(false);
    }
  };

  return (

    <Fragment>

      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.4)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div className="spinner-border text-light" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}

      <Row>

        <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
          <div className="project-box">
            {is_kyc_active ? (<span className={`badge badge-success`}>{"Verified"}</span>) : ''}


            <div className='mt-3'>
              {(is_kyc_submitted || is_kyc_active) ? (
                <>
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Bank Account Number"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="bank_account_number"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_account_number}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Bank Account Number is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.bank_account_number?.message}</span>}
                      </FormGroup>

                      <FormGroup>
                        <Label>{"Bank Account Name"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="bank_account_name"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_account_name}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Bank Account Name is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.bank_account_name?.message}</span>}
                      </FormGroup>

                      <FormGroup>
                        <Label>{"IFSC Code"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="ifsc_code"
                          type="text"
                          defaultValue={kycData.bankDetails?.ifsc_code}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "IFSC Code is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.ifsc_code?.message}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Bank Name"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="bank_name"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_name}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Bank Name is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.bank_name?.message}</span>}
                      </FormGroup>
                      <KycViewNote />
                    </Col>

                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label> Cancelled Cheque</Label>
                        <FileUploadComponent
                          name="cancelled_cheque_image"
                          fileUploadFlag={false}
                          data={kycData?.bankDetails?.cancelled_cheque_image}
                          viewOnly={!isEditing}
                          register={isEditing ? register : undefined}
                          setValue={isEditing ? setValue : undefined}
                          trigger={isEditing ? trigger : undefined}
                          getValues={isEditing ? getValues : undefined}
                          add={isEditing ? (getValues()["cancelled_cheque_image"]?.length > 0 ? false : true) : undefined}
                          pdfImageOnly={isEditing ? true : undefined}
                          required={false}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.cancelled_cheque_image && "Cancelled Cheque Document is Required"}</span>}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto" className="d-flex gap-2">
                      {isEditing ? (
                        <>
                          <Button type="button" color="secondary" onClick={() => setIsEditing(false)} className="mr-2">
                            Cancel
                          </Button>
                          <Button type="button" color="success" onClick={handleSubmit(handleEditSave)} disabled={loading}>
                            Submit
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button type="button" color="warning" onClick={() => { setOriginalValues({ ...kycData.bankDetails }); setIsEditing(true); }} className="mr-2">
                            <Edit fontSize="small" /> Edit
                          </Button>
                          <Button type="button" color="info" onClick={onSubmitForKycSubmitComplete}>
                            Next
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                </>
              ) : getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" && (
                <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Bank Account Number"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_account_number"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Bank Account Number is required"))}
                          defaultValue={getValues()["bank_account_number"]}

                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_account_number?.message}
                        </span>
                      </FormGroup>

                      <FormGroup>
                        <Label>{"Bank Account Name"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_account_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Bank Account Name is required"))}
                          defaultValue={getValues()["bank_account_name"]}
                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_account_name?.message}
                        </span>
                      </FormGroup>

                      <FormGroup>
                        <Label>{"IFSC Code"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="ifsc_code"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "IFSC Code is required"))}
                          defaultValue={getValues()["ifsc_code"]}
                        />
                        <span style={{ color: "red" }}>
                          {errors.ifsc_code?.message}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Bank Name"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Bank Name is required"))}
                          defaultValue={getValues()["bank_name"]}
                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_name?.message}
                        </span>
                      </FormGroup>
                      <KycEditNote />
                    </Col>

                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className='text-center'>
                        <Label>{"Upload cancelled cheque document"}</Label> <RequiredIndicator />

                        <FileUploadComponent
                          register={register}
                          name="cancelled_cheque_image"
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          data={cancelChequeUrl}
                          add={getValues()["cancelled_cheque_image"]?.length > 0 ? false : true}
                          pdfImageOnly={true}
                        />
                        <span style={{ color: "red" }}>
                          {errors.cancelled_cheque_image && "Cancelled Cheque Document is Required"}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          &lt;&lt; Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      <Button type="submit" color="info">
                        Save <span>&gt;&gt;</span>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </div>

          </div>
        </Col>

      </Row>
    </Fragment>
  )
};

export default BankDetails;
